module.exports = __webpack_public_path__ + "static/media/calendario.5c53cdbd.svg";